import React from 'react';
import PropTypes from 'prop-types';

import Card from 'components/Card';
import Field from 'components/Field';
import Translator from 'utils/enumTranslator';

import 'Modals/modals.scss';

const AddressDetail = ({ object }) => {
  const ipType = Translator.protocolType(object.type);

  return (
    <div className="modal__content padded new-address-survey">
      <Card header={false}>
        <div className="form-row">
          <Field.Group label="Name" extraClass="flex-3">
            <Field.Text extraClass="object-name" text={object.name} title={object.name} />
          </Field.Group>
          <Field.Group label={ipType.label} extraClass="flex-2">
            <Field.Text text={object.address} />
          </Field.Group>
        </div>
        {!!object.description && (
          <Field.Group label="Description" full>
            <Field.Text text={object.description} />
          </Field.Group>
        )}
      </Card>
    </div>
  );
};

AddressDetail.propTypes = {
  object: PropTypes.object.isRequired,
};

export default AddressDetail;
